import { Record, OrderedMap, List, Range } from "immutable";
import { formatCurrency } from "utilities/currency";
import moment from "moment";

export class SupplyChainRecord extends Record({
    uapr: null,
    ledger_name: null,
    ledger_master_id: null,
    ledger_gstin: null,
    tally_company_code: null,
    amount_bounces: null,
    amount_dpd_95_perc_amt_gt_0: null,
    amount_dpd_95_perc_amt_gt_0_perc: null,
    amount_dpd_95_perc_amt_gt_30: null,
    amount_dpd_95_perc_amt_gt_30_perc: null,
    amount_dpd_95_perc_amt_gt_60: null,
    amount_dpd_95_perc_amt_gt_60_perc: null,
    amount_dpd_95_perc_amt_gt_90: null,
    amount_dpd_95_perc_amt_gt_90_perc: null,
    amount_os_gt_30: null,
    amount_os_gt_60: null,
    amount_os_gt_90: null,
    amount_os_gt_120: null,
    amount_os_gt_150: null,
    amount_os_gt_180: null,
    amount_paid_invoices: null,
    amount_repayments: null,
    amount_sales: null,
    amount_sales_return: null,
    amount_successful_repayments: null,
    amount_unpaid_invoices: null,
    analysis_end_date: null,
    analysis_period_in_months: 6,
    analysis_start_date: null,
    average_pbr: null,
    average_pbs: null,
    avg_monthly_no_repayments: null,
    avg_monthly_no_sales: null,
    bounces_to_repayments_perc: null,
    case: null,
    company: null,
    create_date: null,
    created_by: null,
    date_of_appointment: null,
    id: null,
    is_active: true,
    last_receipt_date: null,
    last_sales_date: null,
    limit_basis_90_pctl: null,
    limit_basis_sales: null,
    modified_by: null,
    modified_date: null,
    no_bounces: null,
    no_dpd_95_perc_amt_gt_0: null,
    no_dpd_95_perc_amt_gt_0_perc: null,
    no_dpd_95_perc_amt_gt_30: null,
    no_dpd_95_perc_amt_gt_30_perc: null,
    no_dpd_95_perc_amt_gt_60: null,
    no_dpd_95_perc_amt_gt_60_perc: null,
    no_dpd_95_perc_amt_gt_90: null,
    no_dpd_95_perc_amt_gt_90_perc: null,
    no_paid_invoices: null,
    no_repayments: null,
    no_sales: null,
    no_successful_repayments: null,
    no_unpaid_invoices: null,
    os_bal_90_pctl: null,
    os_bal_mean: null,
    os_bal_median: null,
    proposed_limit: null,
    repayment_period_90_pctl: null,
    repayment_period_mean: null,
    repayment_period_median: null,
    retailer_share_of_the_total_sales_perc: null,
    system_recommendation: null,
    score_obtained: null,
    oldest_invoice_os_date: null,
    oldest_invoice_os_ageing: null,
    oldest_invoice_os_amount: null,
    oldest_invoice_os_unpaid_amount: null,
    max_score: null,
    avg_repayment_period: null,
    avg_monthly_net_sales: null,
    net_sales_amount_last_12_months: null,
    limit_basis_sales_display: null,
    net_sales_amount: null
}) {
    get statsList() {
        return new OrderedMap({}).withMutations(map => {
            map.set("business_vintage_with_anchor", {
                label: "Vintage (in months)",
                // value: moment
                //     .duration(moment().diff(this.date_of_appointment))
                //     .months()
                value: Math.round(moment().diff(moment(this.date_of_appointment), "months", true))
            })

                .set("retailer_share_of_the_total_sales_perc", {
                    label: "Dependence of distributor on retailer (%)",
                    value: this.retailer_share_of_the_total_sales_perc
                })
                .set("no_bounces", {
                    value: this.no_bounces,
                    label: "Cheque Bounces"
                })
                .set("repayment_period_mean", {
                    label: "Promptness of Repayment (in days)",
                    value: this.avg_repayment_period
                })
                .set("avg_monthly_no_sales", {
                    value: this.avg_monthly_no_sales,
                    label: "Level of Engagement (Sales)"
                })
                .set("avg_monthly_no_repayments", {
                    value: this.avg_monthly_no_repayments,
                    label: "Level of Engagement (Repayments)"
                })

                .set("sales_per_defined_season_and_average_sales", {
                    label: "Sales - During season / Average",
                    value: `${0} / ${0}`,
                    span: 2
                });
            /* .set("average_sales", {
                    label: "Average Sales",
                    value: 0,
                    span: 2
                }) */
        });
    }

    get supplyChainLimitList() {
        return new OrderedMap({}).withMutations(map => {
            map.set("limit_basis_sales", {
                label: "Proposed Limit as per Sales",
                value: this.limit_basis_sales
            })
                .set("limit_basis_90_pctl", {
                    label: "Proposed Limit as per 90 percentile",
                    value: this.limit_basis_90_pctl
                })
                .set("proposed_limit", {
                    label: "Proposed Limit",
                    value: this.proposed_limit
                });
        });
    }

    get supplyChainScoreCardList() {
        return new OrderedMap({}).withMutations(map => {
            map
                .set("repayment_period_mean", {
                    label: "Avg. Repayment Period",
                    value: this.avg_repayment_period
                })
                .set("oldest_invoice_os_date", {
                    label: "Oldest O/S Invoice Details (Date | Ageing | O/S Amount)",
                    value: `${this.oldest_invoice_os_date || "N/A"} | ${this.oldest_invoice_os_ageing || "N/A"} | ${this.oldest_invoice_os_unpaid_amount || "N/A"}` 
                }); 
        });
    }
}
const years = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
export class SupplyChainFinancialsRecord extends Record({
    data: new List([])
}) {
    getCols(yearType) {
        // const startMonth = yearType === 1 ? 3 : 0;
        let startMonth = 0;
        if (yearType == 1) {
            startMonth = 3;
        }
        if (yearType == 3) {
            startMonth = 7;
        }

        const yearMap = new Range(0, 12)
            .toList()
            .map(_ => {
                const offsetMonth = startMonth + _;
                if (offsetMonth >= 12) {
                    return offsetMonth - 12;
                }
                return offsetMonth;
            })
            .map(_ => years[_])
            // .unshift(["year", "total_sales"])
            .toOrderedMap()
            .mapEntries(([, v]) => [v, v]);
        return yearMap;
    }
    getRows(yearType) {
        let startMonth = 0;
        if (yearType == 1) {
            startMonth = 3;
        }
        if (yearType == 3) {
            startMonth = 7;
        }
        const yearMap = new Range(0, 12)
            .toList()
            .map(_ => {
                const offsetMonth = startMonth + _;
                if (offsetMonth >= 12) {
                    return offsetMonth - 12;
                }
                return offsetMonth;
            })
            .map(_ => years[_])
            .toOrderedMap()
            .mapEntries(([, v]) => [v, 0]);
        const YearRecord = class YearRecord extends Record({
            year: null,
            ...yearMap.toJS()
        }) {
            get total_sales() {
                return this.toSeq()
                    .toMap()
                    .filter((v, k) => k !== "year")
                    .toList()
                    .reduce((agg, cur) => agg + cur, 0);
            }
        };
        return this.data
            .toMap()
            .mapEntries(([, v]) => {
                const date = Object.keys(v)[0];
                return [date, v[date]];
            })
            .groupBy((_, k) => {
                const [year, month] = k.split("-");
                if (+month - 1 < startMonth) {
                    return String(+year - 1);
                }
                return year;
            })
            .filter((_, year) => {
                let currentMonth = moment().month();
                let currentYear = moment().year();
                if(+year === currentYear && currentMonth < 3) {
                    return false;
                }
                return true;
            })
            .map(
                (_, year) => {
                    return new YearRecord({
                        year:
                            startMonth === 0
                                ? year
                                : year + "-" + String(+year + 1).slice(-2),
                        ..._.mapEntries(([k, v]) => [
                            years[Number(k.split("-")[1] - 1)],
                            v
                        ]).toJS()
                    });
                }
            )
            .toList()
            .sort((a, b) => {
                const firstYear = Number(a.year.split("-")[0]);
                const secondYear = Number(b.year.split("-")[0]);

                if (firstYear < secondYear) {
                    return -1;
                }
                if (firstYear > secondYear) {
                    return 1;
                }
                if (firstYear === secondYear) {
                    return 0;
                }
            })
            .takeLast(3);
    }
}
export class TotalRepaymentRecord extends Record({
    data: new List([])
}) {
    getCols(yearType) {
        // const startMonth = yearType === 1 ? 3 : 0;
        let startMonth = 0;
        if (yearType == 1) {
            startMonth = 3;
        }
        if (yearType == 3) {
            startMonth = 7;
        }

        const yearMap = new Range(0, 12)
            .toList()
            .map(_ => {
                const offsetMonth = startMonth + _;
                if (offsetMonth >= 12) {
                    return offsetMonth - 12;
                }
                return offsetMonth;
            })
            .map(_ => years[_])
            // .unshift(["year", "total_sales"])
            .toOrderedMap()
            .mapEntries(([, v]) => [v, v]);
        return yearMap;
    }
    getRows(yearType) {
        let startMonth = 0;
        if (yearType == 1) {
            startMonth = 3;
        }
        if (yearType == 3) {
            startMonth = 7;
        }
        const yearMap = new Range(0, 12)
            .toList()
            .map(_ => {
                const offsetMonth = startMonth + _;
                if (offsetMonth >= 12) {
                    return offsetMonth - 12;
                }
                return offsetMonth;
            })
            .map(_ => years[_])
            .toOrderedMap()
            .mapEntries(([, v]) => [v, 0]);
        const YearRecord = class YearRecord extends Record({
            year: null,
            ...yearMap.toJS()
        }) {
            get total_sales() {
                return this.toSeq()
                    .toMap()
                    .filter((v, k) => k !== "year")
                    .toList()
                    .reduce((agg, cur) => agg + cur, 0);
            }
        };
        return this.data
            .toMap()
            .mapEntries(([, v]) => {
                const date = Object.keys(v)[0];
                return [date, v[date]];
            })
            .groupBy((_, k) => {
                const [year, month] = k.split("-");
                if (+month - 1 < startMonth) {
                    return String(+year - 1);
                }
                return year;
            })
            .filter((_, year) => {
                let currentMonth = moment().month();
                let currentYear = moment().year();
                if(+year === currentYear && currentMonth < 3) {
                    return false;
                }
                return true;
            })
            .map(
                (_, year) => {
                    return new YearRecord({
                        year:
                            startMonth === 0
                                ? year
                                : year + "-" + String(+year + 1).slice(-2),
                        ..._.mapEntries(([k, v]) => [
                            years[Number(k.split("-")[1] - 1)],
                            v
                        ]).toJS()
                    });
                }
            )
            .toList()
            .sort((a, b) => {
                const firstYear = Number(a.year.split("-")[0]);
                const secondYear = Number(b.year.split("-")[0]);

                if (firstYear < secondYear) {
                    return -1;
                }
                if (firstYear > secondYear) {
                    return 1;
                }
                if (firstYear === secondYear) {
                    return 0;
                }
            })
            .takeLast(3);
    }
}
export class LedgerAnalysisRecord extends Record({
    id: null,
    uapr: null,
    ledger_name: null,
    ledger_master_id: null,
    ledger_gstin: null,
    tally_company_code: null,
    date_of_appointment: null,
    no_sales: null,
    no_repayments: null,
    no_repayments_last_1_year: null,
    no_days: null,
    no_months: null,
    mw_updated_on: null,
    avg_monthly_no_sales: null,
    avg_monthly_no_repayments: null,
    no_dpd_95_perc_amt_gt_0: null,
    no_dpd_95_perc_amt_gt_0_perc: null,
    no_dpd_95_perc_amt_gt_30: null,
    no_dpd_95_perc_amt_gt_30_perc: null,
    no_dpd_95_perc_amt_gt_60: null,
    no_dpd_95_perc_amt_gt_60_perc: null,
    no_dpd_95_perc_amt_gt_90: null,
    no_dpd_95_perc_amt_gt_90_perc: null,
    no_bounces: null,
    bounces_to_repayments_perc: null,
    net_sales: null,
    avg_monthly_net_sales: null,
    mean_os: null,
    os_bal_25_pctl: null,
    median_os: null,
    os_bal_75_pctl: null,
    os_bal_90_pctl: null,
    closing_balance: null,
    avg_repayment_period: null,
    oldest_invoice_os_date: null,
    oldest_invoice_os_ageing: null,
    oldest_invoice_os_amount: null,
    oldest_invoice_os_unpaid_amount: null,
    sales_last_12_months: null,
    sales_amount_last_12_months: null,
    sales_return_last_12_months: null,
    sales_return_amount_last_12_months: null,
    net_sales_last_12_months: null,
    net_sales_amount_last_12_months: null,
    limit_basis_sales: null,
    limit_basis_os: null,
    no_active_months_in_last_12_months: null,
    no_sales_months_in_last_12_months: null,
    average_monthly_value_of_sales: null,
    is_eligible_vintage: null,
    is_eligible_limit: null,
    limit_basis_sales_display: null
}) {
    get date_appointment() {
        return this.date_of_appointment
            ? moment(this.date_of_appointment).format("DD/MM/YYYY")
            : "--";
    }

    get overdues_0() {
        return this.no_dpd_95_perc_amt_gt_0
            ? `${
                this.no_dpd_95_perc_amt_gt_0 < 10
                    ? "0" + this.no_dpd_95_perc_amt_gt_0
                    : this.no_dpd_95_perc_amt_gt_0
            } | ${formatCurrency(
                Number(this.no_dpd_95_perc_amt_gt_0_perc),
                true
            )}%`
            : "| ";
    }
    get overdues_30() {
        return this.no_dpd_95_perc_amt_gt_30
            ? `${
                this.no_dpd_95_perc_amt_gt_30 < 10
                    ? "0" + this.no_dpd_95_perc_amt_gt_30
                    : this.no_dpd_95_perc_amt_gt_30
            } | ${formatCurrency(
                Number(this.no_dpd_95_perc_amt_gt_30_perc),
                true
            )}%`
            : "| ";
    }
    get overdues_60() {
        return this.no_dpd_95_perc_amt_gt_60
            ? `${
                this.no_dpd_95_perc_amt_gt_60 < 10
                    ? "0" + this.no_dpd_95_perc_amt_gt_60
                    : this.no_dpd_95_perc_amt_gt_60
            } | ${formatCurrency(
                Number(this.no_dpd_95_perc_amt_gt_60_perc),
                true
            )}%`
            : "| ";
    }
    get overdues_90() {
        return this.no_dpd_95_perc_amt_gt_90
            ? `${
                this.no_dpd_95_perc_amt_gt_90 < 10
                    ? "0" + this.no_dpd_95_perc_amt_gt_90
                    : this.no_dpd_95_perc_amt_gt_90
            } | ${formatCurrency(
                Number(this.no_dpd_95_perc_amt_gt_90_perc),
                true
            )}%`
            : "|";
    }

    get bounces() {
        return this.no_bounces
            ? `${
                this.no_bounces < 10 ? "0" + this.no_bounces : this.no_bounces
            } | ${this.bounces_to_repayments_perc}`
            : "|";
    }
}

export class LedgerAnalysisSummaryRecord extends Record({
    create_date: null,
    created_by: null,
    current_status: null,
    distributor_name: null,
    tenor: null,
    id: null,
    is_active: null,
    minimum_vintage: null,
    minimum_limit: null,
    modified_by: null,
    modified_date: null,
    no_ledgers_analyzed: null,
    no_ledgers_eligible: null,
    net_sales_amount_last_12_months: null,
    net_sales_last_12_months_eligible: null,
    remarks: null,
    request_id: null,
    sales_last_12_months: null,
    sales_last_12_months_eligible: null,
    sales_return_last_12_months: null,
    sales_return_last_12_months_eligible: null,
    tally_company_code: null,
    triggered_at: null
}) {
    get ledgers_eligible_perc() {
        return this.no_ledgers_analyzed
            ? (
                (+this.no_ledgers_eligible * 100) /
                  +this.no_ledgers_analyzed
            ).toFixed(0)
            : "--";
    }

    get net_sales_last_12_months_eligible_perc() {
        return this.net_sales_last_12_months_eligible
            ? (
                (+this.net_sales_last_12_months_eligible * 100) /
                  +this.net_sales_amount_last_12_months
            ).toFixed(0)
            : "--";
    }

    get summaryList() {
        return this.toSeq()
            .toOrderedMap()
            .filter((v, k) =>
                [
                    "distributor_name",
                    "tenor",
                    // "minimum_vintage",
                    // "minimum_limit",
                    "no_ledgers_analyzed",
                    "no_ledgers_eligible",
                    "net_sales_amount_last_12_months",
                    // "net_sales_last_12_months_eligible"
                ].includes(k)
            )
            // s.set("minimum_limit", formatCurrency(this.minimum_limit, true))
            .set(
                "net_sales_amount_last_12_months",
                formatCurrency(this.net_sales_amount_last_12_months, true)
            )
            .set(
                "no_ledgers_eligible",
                `${this.no_ledgers_eligible} (${this.ledgers_eligible_perc} %)`
            )
            // .set(
            //     "net_sales_last_12_months_eligible",
            //     `${formatCurrency(
            //         this.net_sales_last_12_months_eligible,
            //         true
            //     )} (${+this.net_sales_last_12_months_eligible_perc} %)`
            // )
            .mapEntries(([k, v]) => {
                let newKey = "";
                if (k === "distributor_name") {
                    newKey = "Distributor";
                }
                if (k === "tenor") {
                    newKey = "Tenor";
                }

                if (k === "minimum_vintage") {
                    newKey = "Minimum Vintage (in mos)";
                }

                if (k === "minimum_limit") {
                    newKey = "Minimum Limit (in INR)";
                }

                if (k === "no_ledgers_analyzed") {
                    newKey = "Ledgers analyzed";
                }
                if (k === "no_ledgers_eligible") {
                    newKey = "Eligible Ledgers";
                }
                if (k === "net_sales_amount_last_12_months") {
                    newKey = "Sales (last 12 months)";
                }
                // if (k === "net_sales_last_12_months_eligible") {
                //     newKey = "Sales Coverage";
                // }
                return [newKey, v];
            });
    }
}
